import { forwardRef, memo, type Ref, type SVGProps } from "react";

type Props = SVGProps<SVGSVGElement> & {
  size?: number | string;
  color?: string;
};

const SvgComponent = (
  { size = "1em", color = "currentColor", ...props }: Props,
  ref: Ref<SVGSVGElement>
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 10 10"
      fill="none"
      ref={ref}
      {...props}
    >
      <path
        fill={color}
        d="m7.01 0 2.903 2.903V7.01L7.01 9.913H2.903L0 7.01V2.903L2.903 0H7.01ZM4.434 6.521v1.044h1.044V6.52H4.434Zm0-4.174v3.13h1.044v-3.13H4.434Z"
      />
    </svg>
  );
};

const ForwardRef = forwardRef(SvgComponent);
const Memo = memo(ForwardRef);

export { Memo as SpamFill };
